import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = {
    key: 0,
    class: "row mt-4"
};
const _hoisted_3 = { class: "col-md-3 col-4" };
const _hoisted_4 = { class: "col-md-3 col-4" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "d-none col-3 d-md-block" }, null, -1);
const _hoisted_6 = { class: "col-md-3 col-4" };
const _hoisted_7 = { class: "col-md-3 col-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "d-none col-md-6 d-md-block" }, null, -1);
const _hoisted_9 = { class: "col-md-3 col-6" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.content, (tContent) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                    key: tContent.member
                }, [
                    (tContent.isVisible)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$forms.componentElementName(tContent.elementType)), {
                            key: 0,
                            schema: _ctx.schema,
                            content: tContent,
                            data: _ctx.data,
                            onCommand: _ctx.onCommand
                        }, null, 8, ["schema", "content", "data", "onCommand"]))
                        : _createCommentVNode("", true)
                ], 64));
            }), 128))
        ]),
        (_ctx.page.pageType == 'data')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.page.isMultiPageChild)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_3, [
                            (!_ctx.page.isFirstPage)
                                ? (_openBlock(), _createBlock(_component_g_button, {
                                    key: 0,
                                    text: "<< Zurück",
                                    "button-style": "btn-outline-secondary",
                                    disabled: !_ctx.page.previousPage,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onCommand('back', { page: _ctx.page }))),
                                    isLoading: _ctx._isWorking
                                }, null, 8, ["disabled", "isLoading"]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_g_button, {
                                text: "zur Übersicht",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.onCommand('page-goto-master', { page: _ctx.page }))),
                                isLoading: _ctx._isWorking
                            }, null, 8, ["isLoading"])
                        ]),
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_g_button, {
                                text: _ctx.page.nextText,
                                disabled: !_ctx.page.nextCommand2,
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.onCommand(_ctx.page?.nextCommand2, { page: _ctx.page }))),
                                isLoading: _ctx._isWorking
                            }, null, 8, ["text", "disabled", "isLoading"])
                        ])
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_7, [
                            (!_ctx.page.isFirstPage)
                                ? (_openBlock(), _createBlock(_component_g_button, {
                                    key: 0,
                                    text: "<< Zurück",
                                    "button-style": "btn-outline-secondary",
                                    disabled: !_ctx.page.previousPage,
                                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.onCommand('back', { page: _ctx.page }))),
                                    isLoading: _ctx._isWorking
                                }, null, 8, ["disabled", "isLoading"]))
                                : _createCommentVNode("", true)
                        ]),
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_g_button, {
                                text: _ctx.page.nextText,
                                disabled: !_ctx.page.nextCommand2,
                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.onCommand(_ctx.page?.nextCommand2, { page: _ctx.page }))),
                                isLoading: _ctx._isWorking
                            }, null, 8, ["text", "disabled", "isLoading"])
                        ])
                    ], 64))
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
